// M12.2 — Read-only pill that renders a date range + compare clause.
// Used on /share/:token (where the viewer can't change the window) and
// as a compact indicator anywhere we want to echo "what range am I
// looking at" without a full selector.

import { cn } from "@/lib/utils";
import { compareLabel, formatDateRangeLabel, type ReportCompare } from "@shared/report/date-range";

export interface DateRangeChipProps {
  startDate: string;
  endDate: string;
  compare: ReportCompare;
  comparePeriodStart: string | null;
  comparePeriodEnd?: string | null;
  className?: string;
}

export function DateRangeChip({
  startDate,
  endDate,
  compare,
  comparePeriodStart,
  comparePeriodEnd,
  className,
}: DateRangeChipProps) {
  const base = formatDateRangeLabel(startDate, endDate);
  const compareClause = compareLabel(
    compare,
    startDate,
    endDate,
    comparePeriodStart,
    comparePeriodEnd,
  );
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-medium text-neutral-700 ring-1 ring-neutral-950/10",
        className,
      )}
    >
      <i className="fa-regular fa-calendar text-[11px] text-purple-600" aria-hidden="true" />
      <span>{base}</span>
      {compareClause ? (
        <>
          <span aria-hidden="true" className="text-neutral-300">
            ·
          </span>
          <span className="text-neutral-500">{compareClause}</span>
        </>
      ) : null}
    </span>
  );
}
